import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "crud-container" }
const _hoisted_2 = { class: "button-container" }
const _hoisted_3 = {
  key: 0,
  class: "crud-table"
}
const _hoisted_4 = ["onClick"]
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "pagination" }
const _hoisted_7 = ["disabled"]
const _hoisted_8 = ["disabled"]
const _hoisted_9 = {
  key: 1,
  class: "dialog"
}
const _hoisted_10 = { class: "dialog-content" }
const _hoisted_11 = ["onUpdate:modelValue"]
const _hoisted_12 = ["onClick"]
const _hoisted_13 = { class: "dialog-actions" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("button", {
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.openCreateDialog && _ctx.openCreateDialog(...args))),
        class: "create-btn"
      }, "Create Product")
    ]),
    (_ctx.items.length)
      ? (_openBlock(), _createElementBlock("table", _hoisted_3, [
          _cache[8] || (_cache[8] = _createElementVNode("thead", null, [
            _createElementVNode("tr", null, [
              _createElementVNode("th", null, "Product Id"),
              _createElementVNode("th", null, "Name"),
              _createElementVNode("th", null, "Amount"),
              _createElementVNode("th", null, "Actions")
            ])
          ], -1)),
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item) => {
              return (_openBlock(), _createElementBlock("tr", {
                key: item._id
              }, [
                _createElementVNode("td", null, _toDisplayString(item._id), 1),
                _createElementVNode("td", null, _toDisplayString(item.name), 1),
                _createElementVNode("td", null, _toDisplayString(item.amount), 1),
                _createElementVNode("td", null, [
                  _createElementVNode("button", {
                    onClick: ($event: any) => (_ctx.openEditDialog(item)),
                    class: "edit-btn"
                  }, "Edit", 8, _hoisted_4),
                  _createElementVNode("button", {
                    onClick: ($event: any) => (_ctx.deleteItem(item._id)),
                    class: "delete-btn"
                  }, "Delete", 8, _hoisted_5)
                ])
              ]))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("button", {
        disabled: _ctx.page === 1,
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.changePage(_ctx.page - 1)))
      }, "Previous", 8, _hoisted_7),
      _createElementVNode("span", null, "Page " + _toDisplayString(_ctx.page) + " of " + _toDisplayString(_ctx.totalPages), 1),
      _createElementVNode("button", {
        disabled: _ctx.page === _ctx.totalPages,
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.changePage(_ctx.page + 1)))
      }, "Next", 8, _hoisted_8)
    ]),
    (_ctx.dialog)
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("h3", null, _toDisplayString(_ctx.isEdit ? 'Edit Item' : 'Create Item'), 1),
            _cache[11] || (_cache[11] = _createElementVNode("br", null, null, -1)),
            _createElementVNode("label", null, [
              _cache[9] || (_cache[9] = _createTextVNode(" Name ")),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.itemForm.name) = $event))
              }, null, 512), [
                [_vModelText, _ctx.itemForm.name]
              ])
            ]),
            _createElementVNode("label", null, [
              _cache[10] || (_cache[10] = _createTextVNode(" Amount ")),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.itemForm.amount) = $event))
              }, null, 512), [
                [_vModelText, _ctx.itemForm.amount]
              ])
            ]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.itemForm.items, (subItem, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: index,
                class: "sub-item"
              }, [
                _createElementVNode("h4", null, "Item " + _toDisplayString(index + 1), 1),
                _createElementVNode("label", null, [
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": ($event: any) => ((subItem.name) = $event)
                  }, null, 8, _hoisted_11), [
                    [_vModelText, subItem.name]
                  ])
                ]),
                _createElementVNode("button", {
                  onClick: ($event: any) => (_ctx.removeSubItem(index)),
                  class: "remove-btn"
                }, "Remove Item", 8, _hoisted_12)
              ]))
            }), 128)),
            _createElementVNode("button", {
              onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.addSubItem && _ctx.addSubItem(...args))),
              class: "add-btn"
            }, "Add Item"),
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("button", {
                onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.dialog = false)),
                class: "cancel-btn"
              }, "Cancel"),
              _createElementVNode("button", {
                onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.saveItem && _ctx.saveItem(...args))),
                class: "save-btn"
              }, _toDisplayString(_ctx.isEdit ? 'Save' : 'Create'), 1)
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}